import React, { useState } from 'react'
import {grantPermission} from "../../../hoc/RoleService/RoleService";

const BannerAircraftHighlightedKBD = props => {
    const { auth } = props;
    const [collapsed, setCollapsed] = useState(true);

    const toggleDescription = () => {
        setCollapsed(!collapsed);
    };

    return (
        <div className="box box-notice box-solid collapsible">
            <div className="callout callout-notice">
                <div className="clickable" onClick={toggleDescription.bind(this)}>
                    <button type="button" className="link-button collapse">
                        <i className={collapsed ? "fa fa-chevron-down" : "fa fa-chevron-up"} aria-hidden="true" />
                    </button>

                    <h4>
                        <i className="fa fa-comments-o" /> { props.document.title }
                    </h4>
                </div>

                <div className={collapsed ? "collapsible-wrapper collapsed" : "collapsible-wrapper"}>
                    <blockquote dangerouslySetInnerHTML={{__html: props.document.description}} />

                    {props.document.privateDescription && grantPermission('role_private_kb', auth) ?
                        <blockquote dangerouslySetInnerHTML={{__html: props.document.privateDescription}} />
                    : <></> }
                </div>
            </div>
        </div>
    );
}

export default BannerAircraftHighlightedKBD;
